module.exports = __webpack_public_path__ + "static/media/FiraSans-Light.cfc0a5e8.ttf";